/* @flow */
import Notice from 'components/Notice.jsx';
import * as React from 'react';
import Toast from 'components/Toast.jsx';

/**
 * ## [Toast](/internal/components/Toast) that surfaces a [Notice](/internal/components/Notice) to show an error.
 * ### Used as an unintrusive way to alert the user of an error that occurred doing an action they took. Only use if the error does not prevent the user from completing the action.
 *
 * ```example
 * <ErrorToast>
 *   ErrorToast
 * </ErrorToast>
 * ```
 *
 *
 * # TODO
 * * Consider combining with [Toast](/internal/components/Toast)
 */

const ErrorToast = (props: { children: string }) => (
  <Toast>
    <Notice color="lava" glyph="close">
      {props.children}
    </Notice>
  </Toast>
);

export default ErrorToast;
